import introSec from "../../../../assets/os-security.jpg";
import classrom from "../../../../assets/classrom.jpeg";
import global from "../../../../assets/global.jpeg";
import cyberDiff from "../../../../assets/networkSecurity01.jpeg";
import CybersecurityProgram from "../../Shared/CybersecurityPrograms";

const NetworkOS = () => {
  return (
    <CybersecurityProgram
      backLink="/course/cyber-security"
      heroTitle="Network & OS Security"
      heroSubtitle="Securing the backbone of digital communication and operating environments."
      heroImage={introSec}
      introParagraphs={[
        "Network & OS Security focuses on safeguarding the essential infrastructure that underpins all digital systems. From protecting local and wide-area networks to securing the very operating systems that power devices, this module equips learners with the knowledge to defend critical layers of technology.",
        "At JR Institute of Information Technology, students gain both theoretical foundations and practical skills. You'll explore protocols, permissions, vulnerabilities, and best practices for hardening systems against unauthorized access and malicious activity.",
      ]}
      classroom={{
        image: classrom,
        title: "IN THE CLASSROOM",
        paragraphs: [
          "In the classroom, students dive into network architectures and learn to configure secure topologies using routers, switches, and firewalls. You'll analyze real-world threats such as malware, ransomware, and denial-of-service attacks while practicing mitigation strategies.",
          "Hands-on labs include hardening Windows and Linux operating systems, implementing user authentication policies, and exploring advanced access control models. Through practice, students gain confidence in securing both networks and operating systems.",
        ],
      }}
      beyondClassroom={{
        image: global,
        title: "BEYOND THE CLASSROOM",
        paragraphs: [
          "Beyond the classroom, learners apply their skills through internships, industry simulations, and professional certification tracks like CompTIA Security+ and Cisco CCNA Security.",
          "Graduates of the Network & OS Security module often pursue careers as system administrators, network engineers, or security analysts, contributing directly to the protection of organizational IT infrastructure.",
        ],
      }}
      difference={{
        image: cyberDiff,
        title: "NETWORK & OS SECURITY + THE JRIIT DIFFERENCE",
        paragraphs: [
          "What makes our Network & OS Security training unique is the balance of academic rigor and real-world readiness. Students not only learn concepts but also apply them through realistic attack-and-defense simulations.",
          "With JRIIT’s hands-on approach, graduates stand out in the job market as professionals who can confidently secure operating systems and networks in diverse environments.",
        ],
      }}
    />
  );
};

export default NetworkOS;
